import { ref } from 'vue';
/* global axios */

// FUNCOES RESTRITAS (v87): flags do usuario logado (WhatsApp ao vivo, menu
// Meta, Horario de Uso). Cache de sessao; a Sidebar decide os menus por aqui.
const flags = ref(null);
let pending = null;

const load = async accountId => {
  if (flags.value || pending) {
    await pending;
    return;
  }
  pending = axios
    .get(`/api/v1/accounts/${accountId}/controle_acesso/minhas_funcoes`)
    .then(({ data }) => {
      flags.value = data || {};
    })
    .catch(() => {
      flags.value = {};
    })
    .finally(() => {
      pending = null;
    });
  await pending;
};

export function useRestrictedFeatures(accountId) {
  if (accountId) load(accountId);
  return { restrictedFlags: flags };
}
